import { ButtonHighlight } from "@france/superelements/lib";

import { IonModal } from "@ionic/react";
import "./WarningModal.scss";

interface WarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description: string;
  onFirstAction: () => void;
  firstActionWording: string;
  onSecondAction?: () => void;
  secondActionWording?: string;
  firstActionDisabled?: boolean;
  secondActionDisabled?: boolean;
}

const WarningModal: React.FC<WarningModalProps> = ({
  isOpen,
  onClose,
  title,
  description,
  onFirstAction,
  firstActionWording,
  onSecondAction,
  secondActionWording,
  firstActionDisabled = false,
  secondActionDisabled = false,
}) => (
  <IonModal
    id="WarningModal"
    isOpen={isOpen}
    onWillDismiss={onClose}
    showBackdrop
  >
    <div className="content">
      <h3 className="head">{title}</h3>
      <div className="description">{description}</div>
      <div className="footer">
        <ButtonHighlight
          className="notFilled"
          onClick={onFirstAction}
          name={firstActionWording}
          disabled={firstActionDisabled}
        />
        {!!onSecondAction && !!secondActionWording && (
          <ButtonHighlight
            onClick={onSecondAction}
            name={secondActionWording}
            disabled={secondActionDisabled}
          />
        )}
      </div>
    </div>
  </IonModal>
);

export default WarningModal;
